// Biome colour palette (mirrors Rust BiomeKind::color_hex).

export const BIOME_COLORS: Readonly<Record<string, string>> = {
  plains: '#7ea84a',
  forest: '#3f8d4d',
  hills: '#a39154',
  mountain: '#7d7a72',
  desert: '#d6b87a',
  tundra: '#cfd6da',
  coast: '#5fa6c4',
  ocean: '#345b85',
  river: '#4a90d9',
};

export const UNKNOWN_BIOME_COLOR = '#555555';
/** Unexplored tiles: an opaque neutral — reveals no terrain. */
export const FOG_COLOR = '#2c3541';

export function biomeColor(biome: string): string {
  return BIOME_COLORS[biome] ?? UNKNOWN_BIOME_COLOR;
}
